import { render, staticRenderFns } from "./AddEquipment.vue?vue&type=template&id=8b4e0c96&scoped=true"
import script from "./AddEquipment.vue?vue&type=script&lang=js"
export * from "./AddEquipment.vue?vue&type=script&lang=js"
import style0 from "./AddEquipment.vue?vue&type=style&index=0&id=8b4e0c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4e0c96",
  null
  
)

export default component.exports